import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Void: { input: any; output: any; }
};

export enum BusinessType {
  Business = 'Business',
  FranchiseNew = 'Franchise_New',
  FranchiseResale = 'Franchise_Resale',
  LicenceDistribution = 'Licence_Distribution'
}

export type BusinessTypeInput = {
  id: Scalars['String']['input'];
};

export type Buyer = {
  __typename?: 'Buyer';
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  recommendationPreferences: Maybe<RecommendationPreferences>;
  subscription: Maybe<Subscription>;
  userId: Scalars['String']['output'];
};

export type BuyerData = {
  __typename?: 'BuyerData';
  recommendationPreferences: RecommendationPreferences;
};

export type BuyerRecord = {
  __typename?: 'BuyerRecord';
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneCountryCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ClientContractInput = {
  clientId: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ClientListing = {
  __typename?: 'ClientListing';
  autoRenew: Scalars['Boolean']['output'];
  baseContract: Maybe<ListingBaseContract>;
  canBoost: Scalars['Boolean']['output'];
  clientId: Scalars['Int']['output'];
  contactCount: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  creditRemaining: Scalars['Float']['output'];
  enquiryCount: Scalars['Int']['output'];
  expiryDate: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isListingEmailBoosted: Scalars['Boolean']['output'];
  isPremium: Scalars['Boolean']['output'];
  legacyProductCode: Maybe<Scalars['String']['output']>;
  listingCount: Scalars['Int']['output'];
  /** @deprecated This refers to the .NET productCode. This should be consumed as legacyProductCode */
  productCode: Maybe<Scalars['String']['output']>;
  searchCount: Scalars['Int']['output'];
  status: ListingStatus;
  title: Scalars['String']['output'];
};

export enum ClientStatus {
  Active = 'Active',
  Disabled = 'Disabled',
  Unknown = 'Unknown'
}

export enum ClientType {
  Broker = 'Broker',
  Franchisee = 'Franchisee',
  Franchisor = 'Franchisor',
  LicensingDistribution = 'LicensingDistribution',
  PrivateSeller = 'PrivateSeller',
  Unknown = 'Unknown'
}

export enum ContractStatus {
  Active = 'Active',
  Expired = 'Expired',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type ContractUpgradeRequestInput = {
  listingId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type CreateSavedListingInput = {
  listingId: Scalars['String']['input'];
};

export type CreateSavedSearchInput = {
  clientIds: Array<Scalars['String']['input']>;
  excludePOA?: InputMaybe<Scalars['Boolean']['input']>;
  industryIds: Array<Scalars['String']['input']>;
  industryTagIds: Array<Scalars['String']['input']>;
  investmentLevelMax: Scalars['Int']['input'];
  investmentLevelMin: Scalars['Int']['input'];
  keywords: Array<Scalars['String']['input']>;
  opportunityIds: Array<Scalars['String']['input']>;
  regionIds: Array<Scalars['String']['input']>;
  regionRadius: Scalars['Int']['input'];
  searchName: Scalars['String']['input'];
  searchUrl: Scalars['String']['input'];
  whenListed?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteSavedListingInput = {
  listingId: Scalars['String']['input'];
};

export type DeleteSavedSearchInput = {
  id: Scalars['String']['input'];
  searchName: Scalars['String']['input'];
  searchUrl: Scalars['String']['input'];
};

export type District = {
  __typename?: 'District';
  altTitle: Maybe<Scalars['String']['output']>;
  area: Maybe<DistrictRef>;
  country: Maybe<DistrictRef>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postcode: Maybe<Scalars['String']['output']>;
  region: Maybe<DistrictRef>;
  state: Maybe<DistrictRef>;
  suburb: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type DistrictInput = {
  altTitle?: InputMaybe<Scalars['String']['input']>;
  area?: InputMaybe<DistrictRefInput>;
  country?: InputMaybe<DistrictRefInput>;
  displayTitle: Scalars['String']['input'];
  id: Scalars['String']['input'];
  postcode?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<DistrictRefInput>;
  state?: InputMaybe<DistrictRefInput>;
  suburb?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
  urlKey: Scalars['String']['input'];
};

export type DistrictRef = {
  __typename?: 'DistrictRef';
  id: Scalars['String']['output'];
};

export type DistrictRefInput = {
  id: Scalars['String']['input'];
};

export type ExcludePoaInput = {
  excludePoa: Scalars['Boolean']['input'];
};

export type FeaturedFranchise = {
  __typename?: 'FeaturedFranchise';
  imageUrl: Scalars['String']['output'];
  investment: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  location: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FeaturedListing = {
  __typename?: 'FeaturedListing';
  businessName: Maybe<Scalars['String']['output']>;
  details: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  location: Scalars['String']['output'];
  opportunityType: Scalars['String']['output'];
  price: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type Industries = {
  __typename?: 'Industries';
  industries: Array<Industry>;
};

export type Industry = {
  __typename?: 'Industry';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type IndustryGroup = {
  __typename?: 'IndustryGroup';
  industries: Array<Industry>;
  industryGroupId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type IndustryGroups = {
  __typename?: 'IndustryGroups';
  industryGroups: Array<IndustryGroup>;
};

export type IndustryInput = {
  title: Scalars['String']['input'];
};

export type IndustryTag = {
  __typename?: 'IndustryTag';
  associatedIndustryIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type LegacyContractResponse = {
  __typename?: 'LegacyContractResponse';
  activeDate: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  contractId: Scalars['String']['output'];
  expiryDate: Maybe<Scalars['String']['output']>;
  quantity: Maybe<Scalars['Int']['output']>;
  used: Maybe<Scalars['Int']['output']>;
};

export type LegacyUserView = {
  __typename?: 'LegacyUserView';
  client: Maybe<UserViewClient>;
};

export type ListingBaseContract = {
  __typename?: 'ListingBaseContract';
  activeDate: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  contractId: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['String']['output'];
  expiredDate: Maybe<Scalars['String']['output']>;
  expiryDate: Maybe<Scalars['String']['output']>;
  lastUpdated: Scalars['String']['output'];
  legacyContractId: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  productTitle: Scalars['String']['output'];
  status: ContractStatus;
};

export type ListingDistrict = {
  __typename?: 'ListingDistrict';
  altTitle: Maybe<Scalars['String']['output']>;
  area: Maybe<ListingDistrictRef>;
  country: Maybe<ListingDistrictRef>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  postcode: Maybe<Scalars['String']['output']>;
  region: Maybe<ListingDistrictRef>;
  state: Maybe<ListingDistrictRef>;
  suburb: Maybe<ListingDistrictRef>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export enum ListingDistrictHierarchy {
  Area = 'area',
  Region = 'region',
  State = 'state',
  Suburb = 'suburb'
}

export type ListingDistrictRef = {
  __typename?: 'ListingDistrictRef';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type ListingDistricts = {
  __typename?: 'ListingDistricts';
  districts: Maybe<Array<Maybe<ListingDistrict>>>;
};

export type ListingProduct = {
  __typename?: 'ListingProduct';
  cost: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  legacyProductCode: Scalars['String']['output'];
  productCode: ListingProductCode;
  productToken: Scalars['String']['output'];
};

export enum ListingProductCode {
  Accelerate = 'Accelerate',
  BoostedAd = 'BoostedAd',
  BoostedAdLus = 'BoostedAdLus',
  EmailBoost = 'EmailBoost',
  EmailBoostAndSearchBoost = 'EmailBoostAndSearchBoost',
  EmailBoostAndSearchBoostLus = 'EmailBoostAndSearchBoostLus',
  EmailBoostLus = 'EmailBoostLus',
  Freemium = 'Freemium',
  ListUntilSold = 'ListUntilSold',
  ListUntilSoldAndSearchBoostLus = 'ListUntilSoldAndSearchBoostLus',
  PayPerAcceptedEnquiry = 'PayPerAcceptedEnquiry',
  PayPerEnquiry = 'PayPerEnquiry',
  SixAdPack = 'SixAdPack',
  SixAdPackAndSearchBoost = 'SixAdPackAndSearchBoost',
  Standard = 'Standard',
  StandardAndSearchBoost = 'StandardAndSearchBoost',
  Unknown = 'Unknown'
}

export enum ListingStatus {
  Active = 'Active',
  Draft = 'Draft',
  Expired = 'Expired',
  Pending = 'Pending',
  Unknown = 'Unknown'
}

export type ListingType = {
  __typename?: 'ListingType';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type ListingTypes = {
  __typename?: 'ListingTypes';
  listingTypes: Maybe<Array<Maybe<ListingType>>>;
};

export type MarketplaceInsightsSignupInput = {
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userRegistrationType: UserRegistrationType;
};

/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * A placeholder string.
   * @deprecated Placeholder only
   */
  _empty: Maybe<Scalars['String']['output']>;
  addBuyerPreferencesBusinessType: Maybe<Scalars['Void']['output']>;
  addBuyerPreferencesDistrict: Maybe<Scalars['Void']['output']>;
  addBuyerPreferencesIndustry: Maybe<Scalars['Void']['output']>;
  addBuyerPreferencesKeyword: Maybe<Scalars['Void']['output']>;
  createSavedListing: Maybe<Scalars['Void']['output']>;
  createSavedSearch: Maybe<Scalars['Void']['output']>;
  deleteSavedListing: Maybe<Scalars['Void']['output']>;
  deleteSavedSearch: Maybe<Scalars['Void']['output']>;
  deleteUser: Maybe<Scalars['Void']['output']>;
  marketplaceInsightsSignup: Maybe<Scalars['Void']['output']>;
  notifyBoostedAdSignup: Maybe<Scalars['Void']['output']>;
  notifyExpiredAdRenew: Maybe<Scalars['Void']['output']>;
  onboardUser: Maybe<Scalars['Void']['output']>;
  payPerLeadRegistration: Maybe<Scalars['Void']['output']>;
  postBuyerPreferencesNudgeSubmitted: Maybe<Scalars['Void']['output']>;
  postDripEvent: Maybe<Scalars['Void']['output']>;
  postListing: Maybe<Scalars['Void']['output']>;
  purchaseAdPackV2: Maybe<Scalars['Void']['output']>;
  purchaseAndActivate: Maybe<Scalars['Void']['output']>;
  purchaseFreemium: Maybe<Scalars['Void']['output']>;
  removeBuyerPreferencesBusinessType: Maybe<Scalars['Void']['output']>;
  removeBuyerPreferencesDistrict: Maybe<Scalars['Void']['output']>;
  removeBuyerPreferencesIndustry: Maybe<Scalars['Void']['output']>;
  removeBuyerPreferencesKeyword: Maybe<Scalars['Void']['output']>;
  resetPassword: Maybe<Scalars['Void']['output']>;
  sendEmailVerificationLink: Maybe<Scalars['Void']['output']>;
  tagUser: Maybe<Scalars['Void']['output']>;
  updateBuyerPreferences: RecommendationPreferences;
  updateBuyerPreferencesExcludePoa: Maybe<Scalars['Void']['output']>;
  updateBuyerPreferencesIndustry: Maybe<Scalars['Void']['output']>;
  updateBuyerPreferencesKeywords: Maybe<Scalars['Void']['output']>;
  updateBuyerPreferencesPrice: Maybe<Scalars['Void']['output']>;
  updateSavedSearch: Maybe<Scalars['Void']['output']>;
  updateUser: Maybe<Scalars['Void']['output']>;
  upgradeContractRequest: Maybe<Scalars['Void']['output']>;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationAddBuyerPreferencesBusinessTypeArgs = {
  input: BusinessTypeInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationAddBuyerPreferencesDistrictArgs = {
  input: DistrictRefInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationAddBuyerPreferencesIndustryArgs = {
  input: IndustryInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationAddBuyerPreferencesKeywordArgs = {
  input: Scalars['String']['input'];
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationCreateSavedListingArgs = {
  input: CreateSavedListingInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationCreateSavedSearchArgs = {
  input: CreateSavedSearchInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationDeleteSavedListingArgs = {
  input: DeleteSavedListingInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationDeleteSavedSearchArgs = {
  input: DeleteSavedSearchInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationMarketplaceInsightsSignupArgs = {
  input: MarketplaceInsightsSignupInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationNotifyExpiredAdRenewArgs = {
  input: NotifyExpiredAdRenewInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationOnboardUserArgs = {
  input: OnboardingInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPostBuyerPreferencesNudgeSubmittedArgs = {
  input: PostBuyerPreferenceNudgeInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPostDripEventArgs = {
  input: PostDripEventInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPostListingArgs = {
  id: Scalars['ID']['input'];
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPurchaseAdPackV2Args = {
  input: PurchaseAdPackV2Input;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPurchaseAndActivateArgs = {
  input: PurchaseAndActivateInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationRemoveBuyerPreferencesBusinessTypeArgs = {
  input: BusinessTypeInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationRemoveBuyerPreferencesDistrictArgs = {
  input: DistrictRefInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationRemoveBuyerPreferencesIndustryArgs = {
  input: IndustryInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationRemoveBuyerPreferencesKeywordArgs = {
  input: Scalars['String']['input'];
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationTagUserArgs = {
  input: TagUserInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateBuyerPreferencesArgs = {
  id: Scalars['String']['input'];
  input: UpdateBuyerPreferencesInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateBuyerPreferencesExcludePoaArgs = {
  input: Scalars['Boolean']['input'];
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateBuyerPreferencesIndustryArgs = {
  input: Array<Scalars['String']['input']>;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateBuyerPreferencesKeywordsArgs = {
  input: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateBuyerPreferencesPriceArgs = {
  input: PriceInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateSavedSearchArgs = {
  input: UpdateSavedSearchInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpdateUserArgs = {
  input: UserUpdatedInput;
};


/**
 * The schema's entry-point for mutations.
 *
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUpgradeContractRequestArgs = {
  input: ContractUpgradeRequestInput;
};

export type NotifyExpiredAdRenewInput = {
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

/** An opaque identifier for GraphQL objects. */
export type ObjectIdentifier = {
  __typename?: 'ObjectIdentifier';
  /** The identifier itself. */
  value: Scalars['String']['output'];
};

export type OnboardingInput = {
  abn?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  emailOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneCountryCode?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  userRegistrationType: UserRegistrationType;
};

export type PostBuyerPreferenceNudgeInput = {
  email: Scalars['String']['input'];
  searchCriteria: SearchCriteriaInput;
};

export type PostDripEventInput = {
  action: Scalars['String']['input'];
};

export type Price = {
  __typename?: 'Price';
  max: Maybe<Scalars['Int']['output']>;
  min: Scalars['Int']['output'];
};

export type PriceInput = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min: Scalars['Int']['input'];
};

export type PublicListingRelaxedCriteria = {
  __typename?: 'PublicListingRelaxedCriteria';
  dropped: Maybe<PublicListingSearchCriteriaResponse>;
  used: Maybe<PublicListingSearchCriteriaResponse>;
};

export type PublicListingSearch = {
  __typename?: 'PublicListingSearch';
  expandedListings: Array<SearchListing>;
  expandedRegions: Maybe<Array<SearchListingExpandedRegion>>;
  industries: Array<SearchListingIndustryCount>;
  organicListings: Array<SearchListing>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  premiumListings: Array<SearchListing>;
  relaxedCriteria: Maybe<PublicListingRelaxedCriteria>;
  totalCount: Scalars['Int']['output'];
};

export type PublicListingSearchCriteria = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  excludePOA?: InputMaybe<Scalars['Boolean']['input']>;
  industryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  industryTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investmentLevelMax?: InputMaybe<Scalars['Int']['input']>;
  investmentLevelMin?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionRadius?: InputMaybe<Scalars['Int']['input']>;
  whenListed?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicListingSearchCriteriaResponse = {
  __typename?: 'PublicListingSearchCriteriaResponse';
  clientId: Maybe<Scalars['String']['output']>;
  excludePOA: Maybe<Scalars['Boolean']['output']>;
  industryIds: Maybe<Array<Scalars['String']['output']>>;
  industryTagIds: Maybe<Array<Scalars['String']['output']>>;
  investmentLevelMax: Maybe<Scalars['Int']['output']>;
  investmentLevelMin: Maybe<Scalars['Int']['output']>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  opportunityIds: Maybe<Array<Scalars['String']['output']>>;
  regionIds: Maybe<Array<Scalars['String']['output']>>;
  regionRadius: Maybe<Scalars['Int']['output']>;
  whenListed: Maybe<Scalars['Int']['output']>;
};

export type PublicListingSearchInput = {
  criteria: PublicListingSearchCriteria;
  includePremium: Scalars['Boolean']['input'];
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
  sort?: InputMaybe<PublicListingSort>;
};

export enum PublicListingSort {
  Alphabetical = 'alphabetical',
  Date = 'date',
  Investment = 'investment',
  Location = 'location',
  Popularity = 'popularity',
  Relevance = 'relevance'
}

export type PurchaseAdPackV2Input = {
  clientId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type PurchaseAndActivateInput = {
  clientId: Scalars['String']['input'];
  listingId?: InputMaybe<Scalars['String']['input']>;
  paymentMethodId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type Query = {
  __typename?: 'Query';
  buyer: Maybe<Buyer>;
  clientContracts: Maybe<Array<Maybe<LegacyContractResponse>>>;
  districtSearchAutosuggest: Maybe<ListingDistricts>;
  featuredFranchises: Array<FeaturedFranchise>;
  featuredListings: Maybe<Array<Maybe<FeaturedListing>>>;
  filteredDistricts: Maybe<ListingDistricts>;
  filteredIndustries: Maybe<Industries>;
  filteredListingDistrictsInHierarchies: Maybe<ListingDistricts>;
  getDistrictsByIds: Maybe<ListingDistricts>;
  getIndustries: Maybe<Industries>;
  getIndustriesByIds: Maybe<Industries>;
  getIndustryDisplayNameByIds: Maybe<Scalars['String']['output']>;
  getIndustryGroups: Maybe<IndustryGroups>;
  getListingTypesByIds: Maybe<ListingTypes>;
  listingProducts: Array<ListingProduct>;
  savedListings: Array<SavedListing>;
  savedSearches: Array<SavedSearch>;
  searchListings: PublicListingSearch;
  /** @deprecated Use client side URL encode instead */
  searchUrl: Maybe<Scalars['String']['output']>;
  serpDecodeSearchCriteria: Maybe<SerpSearchCriteria>;
  user: Maybe<User>;
  userView: Maybe<UserView>;
  /** The API version. */
  version: Scalars['String']['output'];
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryClientContractsArgs = {
  queryInput: ClientContractInput;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryDistrictSearchAutosuggestArgs = {
  searchString: InputMaybe<Scalars['String']['input']>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryFeaturedListingsArgs = {
  listingIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryFilteredDistrictsArgs = {
  searchString: InputMaybe<Scalars['String']['input']>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryFilteredIndustriesArgs = {
  searchString: InputMaybe<Scalars['String']['input']>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryFilteredListingDistrictsInHierarchiesArgs = {
  hierarchies: InputMaybe<Array<InputMaybe<ListingDistrictHierarchy>>>;
  searchString: InputMaybe<Scalars['String']['input']>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryGetDistrictsByIdsArgs = {
  districtIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryGetIndustriesByIdsArgs = {
  industryIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryGetIndustryDisplayNameByIdsArgs = {
  industryIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryGetListingTypesByIdsArgs = {
  listingTypeIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QuerySearchListingsArgs = {
  isSyntheticTestCall: InputMaybe<Scalars['Boolean']['input']>;
  queryInput: InputMaybe<PublicListingSearchInput>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QuerySearchUrlArgs = {
  searchUrlInput: InputMaybe<SearchUrlInput>;
};


/**
 * The schema's entry-point for queries.
 *
 * This acts as the public, top-level API from which all queries must start.
 */
export type QuerySerpDecodeSearchCriteriaArgs = {
  url: Scalars['String']['input'];
};

export type RecommendationPreferences = {
  __typename?: 'RecommendationPreferences';
  businessTypes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  districts: Maybe<Array<Maybe<District>>>;
  excludePoa: Scalars['Boolean']['output'];
  industries: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  keywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  price: Maybe<Price>;
};

export type RefDistrict = {
  __typename?: 'RefDistrict';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SavedListing = {
  __typename?: 'SavedListing';
  businessName: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  expiryDate: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  location: Scalars['String']['output'];
  opportunityType: Scalars['String']['output'];
  price: Scalars['String']['output'];
  savedDate: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  clientIds: Maybe<Array<Scalars['String']['output']>>;
  excludePOA: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  industryIds: Maybe<Array<Scalars['String']['output']>>;
  industryTagIds: Maybe<Array<Scalars['String']['output']>>;
  investmentLevelMax: Maybe<Scalars['Int']['output']>;
  investmentLevelMin: Maybe<Scalars['Int']['output']>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  opportunityIds: Maybe<Array<Scalars['String']['output']>>;
  regionIds: Maybe<Array<Scalars['String']['output']>>;
  regionRadius: Maybe<Scalars['Int']['output']>;
  savedDate: Scalars['String']['output'];
  searchName: Scalars['String']['output'];
  searchUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  whenListed: Maybe<Scalars['Int']['output']>;
};

export type SearchCriteriaInput = {
  businessTypes: Array<BusinessType>;
  districtIds: Array<Scalars['String']['input']>;
  excludePoa: Scalars['Boolean']['input'];
  industryIds: Array<Scalars['String']['input']>;
  price: SearchCriteriaPriceInput;
};

export enum SearchCriteriaOpportunityType {
  Business = 'Business',
  FranchiseNew = 'Franchise_New',
  FranchiseResale = 'Franchise_Resale',
  LicenceDistribution = 'Licence_Distribution'
}

export type SearchCriteriaPriceInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type SearchListing = {
  __typename?: 'SearchListing';
  businessName: Maybe<Scalars['String']['output']>;
  client: SearchListingClient;
  district: SearchListingDistrict;
  gccFreeText: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  industry: Industry;
  industryGroup: IndustryGroup;
  industryTag: Maybe<IndustryTag>;
  investment: SearchListingInvestment;
  isFreemium: Scalars['Boolean']['output'];
  opportunityType: SearchCriteriaOpportunityType;
  refreshDate: Scalars['String']['output'];
  showThumbnailImageOnSerp: Scalars['Boolean']['output'];
  summary: Scalars['String']['output'];
  thumbnailImageFileName: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SearchListingClient = {
  __typename?: 'SearchListingClient';
  id: Scalars['Int']['output'];
  linkOutUrl: Maybe<Scalars['String']['output']>;
  profileLogoImageFileName: Maybe<Scalars['String']['output']>;
  type: ClientType;
};

export type SearchListingDistrict = {
  __typename?: 'SearchListingDistrict';
  area: Maybe<SearchListingDistrictLocation>;
  country: Maybe<SearchListingDistrictLocation>;
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  region: Maybe<SearchListingDistrictLocation>;
  state: Maybe<SearchListingDistrictLocation>;
  type: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SearchListingDistrictLocation = {
  __typename?: 'SearchListingDistrictLocation';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SearchListingExpandedRegion = {
  __typename?: 'SearchListingExpandedRegion';
  regionId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SearchListingIndustryCount = {
  __typename?: 'SearchListingIndustryCount';
  count: Scalars['Int']['output'];
  industryGroupId: Scalars['Int']['output'];
  industryId: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SearchListingInvestment = {
  __typename?: 'SearchListingInvestment';
  hasInventorySav: Scalars['Boolean']['output'];
  isNegotiable: Scalars['Boolean']['output'];
  isPoa: Scalars['Boolean']['output'];
  range: SearchListingInvestmentLevel;
};

export type SearchListingInvestmentLevel = {
  __typename?: 'SearchListingInvestmentLevel';
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
};

export type SearchUrlInput = {
  daysSinceListed?: InputMaybe<Scalars['Int']['input']>;
  districtIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  excludePoa?: InputMaybe<Scalars['Boolean']['input']>;
  industryIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  investmentLevelMax?: InputMaybe<Scalars['Int']['input']>;
  investmentLevelMin?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  opportunityIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type SerpSearchCriteria = {
  __typename?: 'SerpSearchCriteria';
  client: Maybe<SerpSearchCriteriaClient>;
  daysSinceListed: Maybe<Scalars['Int']['output']>;
  districts: Maybe<Array<SerpSearchCriteriaDistrict>>;
  excludePoa: Maybe<Scalars['Boolean']['output']>;
  industries: Maybe<Array<SerpSearchCriteriaIndustry>>;
  industryTags: Maybe<Array<SerpSearchIndustryTag>>;
  investmentLevel: Maybe<SerpSearchCriteriaInvestmentLevel>;
  keywords: Maybe<Scalars['String']['output']>;
  opportunityTypes: Maybe<Array<SearchCriteriaOpportunityType>>;
  page: Maybe<Scalars['Int']['output']>;
  radius: Maybe<Scalars['Int']['output']>;
  sort: Maybe<Scalars['Int']['output']>;
};

export type SerpSearchCriteriaClient = {
  __typename?: 'SerpSearchCriteriaClient';
  businessName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SerpSearchCriteriaDistrict = {
  __typename?: 'SerpSearchCriteriaDistrict';
  displayTitle: Scalars['String']['output'];
  id: Scalars['String']['output'];
  region: Maybe<RefDistrict>;
  state: Maybe<SerpSearchCriteriaState>;
  type: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SerpSearchCriteriaIndustry = {
  __typename?: 'SerpSearchCriteriaIndustry';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SerpSearchCriteriaInvestmentLevel = {
  __typename?: 'SerpSearchCriteriaInvestmentLevel';
  max: Maybe<Scalars['Int']['output']>;
  min: Maybe<Scalars['Int']['output']>;
};

export type SerpSearchCriteriaState = {
  __typename?: 'SerpSearchCriteriaState';
  id: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type SerpSearchIndustryTag = {
  __typename?: 'SerpSearchIndustryTag';
  associatedIndustryIds: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  dripId: Scalars['String']['output'];
  subscriptionStatus: Scalars['String']['output'];
  tags: Maybe<Array<Maybe<Tag>>>;
};

export type Tag = {
  __typename?: 'Tag';
  lastUpdated: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type TagUserInput = {
  tags: Array<Scalars['String']['input']>;
};

export type UpdateBuyerPreferencesInput = {
  businessTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  districts?: InputMaybe<Array<InputMaybe<DistrictInput>>>;
  excludePoa: Scalars['Boolean']['input'];
  industries?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<PriceInput>;
};

export type UpdateSavedSearchInput = {
  clientIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excludePOA?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  industryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  industryTagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  investmentLevelMax?: InputMaybe<Scalars['Int']['input']>;
  investmentLevelMin?: InputMaybe<Scalars['Int']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  opportunityIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionRadius?: InputMaybe<Scalars['Int']['input']>;
  savedDate: Scalars['String']['input'];
  searchName: Scalars['String']['input'];
  searchUrl: Scalars['String']['input'];
  whenListed?: InputMaybe<Scalars['Int']['input']>;
};

export type User = {
  __typename?: 'User';
  emailAddress: Scalars['String']['output'];
  emailVerified: Scalars['Boolean']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  /** @deprecated Listings belong to a client rather than a user */
  listings: Maybe<Array<Maybe<UserListing>>>;
  phoneCountryCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  regionId: Maybe<Scalars['String']['output']>;
  subscription: Maybe<Subscription>;
  userId: Scalars['String']['output'];
  userView: Maybe<LegacyUserView>;
};


export type UserListingsArgs = {
  listingId: InputMaybe<Scalars['String']['input']>;
};

export type UserListing = {
  __typename?: 'UserListing';
  enquiries: Maybe<Array<Maybe<UserListingEnquiry>>>;
  industry: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  location: Scalars['String']['output'];
  opportunityType: Scalars['String']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  urlKey: Scalars['String']['output'];
};

export type UserListingEnquiry = {
  __typename?: 'UserListingEnquiry';
  emailAddress: Scalars['String']['output'];
  enquiryId: Scalars['String']['output'];
  lastUpdated: Scalars['String']['output'];
  listingId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phoneCountryCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export enum UserRegistrationType {
  Broker = 'Broker',
  Buyer = 'Buyer',
  Franchisor = 'Franchisor',
  LicensorOrDistributor = 'LicensorOrDistributor',
  Other = 'Other',
  PrivateSeller = 'PrivateSeller',
  RealEstateAgent = 'RealEstateAgent'
}

export type UserUpdatedInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneCountryCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
  regionId: Scalars['String']['input'];
};

export type UserView = {
  __typename?: 'UserView';
  buyer: Maybe<UserViewBuyer>;
  client: Maybe<UserViewClient>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneCountryCode: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  regionId: Maybe<Scalars['String']['output']>;
  subscription: Maybe<Subscription>;
  userId: Scalars['String']['output'];
};

export type UserViewBuyer = {
  __typename?: 'UserViewBuyer';
  savedListings: Array<UserViewSavedListing>;
  savedSearches: Array<UserViewSavedSearch>;
};

export type UserViewClient = {
  __typename?: 'UserViewClient';
  id: Scalars['String']['output'];
  listings: Array<ClientListing>;
  status: ClientStatus;
  type: ClientType;
};

export type UserViewSavedListing = {
  __typename?: 'UserViewSavedListing';
  listingId: Scalars['String']['output'];
  savedDate: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserViewSavedSearch = {
  __typename?: 'UserViewSavedSearch';
  clientIds: Maybe<Array<Scalars['String']['output']>>;
  excludePOA: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  industryIds: Maybe<Array<Scalars['String']['output']>>;
  industryTagIds: Maybe<Array<Scalars['String']['output']>>;
  investmentLevelMax: Maybe<Scalars['Int']['output']>;
  investmentLevelMin: Maybe<Scalars['Int']['output']>;
  keywords: Maybe<Array<Scalars['String']['output']>>;
  opportunityIds: Maybe<Array<Scalars['String']['output']>>;
  regionIds: Maybe<Array<Scalars['String']['output']>>;
  regionRadius: Maybe<Scalars['Int']['output']>;
  savedDate: Scalars['String']['output'];
  searchName: Scalars['String']['output'];
  searchUrl: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  whenListed: Maybe<Scalars['Int']['output']>;
};

export type GetUserEmailVerifiedQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserEmailVerifiedQuery = { __typename?: 'Query', user: { __typename?: 'User', emailAddress: string, emailVerified: boolean } | null };

export type SendEmailVerificationLinkMutationVariables = Exact<{ [key: string]: never; }>;


export type SendEmailVerificationLinkMutation = { __typename?: 'Mutation', sendEmailVerificationLink: any | null };

export type GetDistrictsByIdsQueryVariables = Exact<{
  queryInput: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetDistrictsByIdsQuery = { __typename?: 'Query', getDistrictsByIds: { __typename?: 'ListingDistricts', districts: Array<{ __typename?: 'ListingDistrict', id: string, displayTitle: string } | null> | null } | null };

export type GetListingsTabQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingsTabQuery = { __typename?: 'Query', user: { __typename?: 'User', userView: { __typename?: 'LegacyUserView', client: { __typename?: 'UserViewClient', id: string, status: ClientStatus, type: ClientType, listings: Array<{ __typename?: 'ClientListing', id: number, autoRenew: boolean, clientId: number, createdDate: string, creditRemaining: number, expiryDate: string | null, isDeleted: boolean, legacyProductCode: string | null, status: ListingStatus, title: string, contactCount: number, enquiryCount: number, listingCount: number, searchCount: number, isListingEmailBoosted: boolean, isPremium: boolean, canBoost: boolean, baseContract: { __typename?: 'ListingBaseContract', status: ContractStatus, clientId: string, lastUpdated: string, productCode: string, createdDate: string, listingId: string, legacyContractId: string, productTitle: string, expiryDate: string | null, expiredDate: string | null, activeDate: string | null, contractId: string | null } | null }> } | null } | null } | null, listingProducts: Array<{ __typename?: 'ListingProduct', cost: number, legacyProductCode: string, productCode: ListingProductCode, productToken: string }> };

export type GetPrivateSellerEnquiriesQueryVariables = Exact<{
  listingId: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPrivateSellerEnquiriesQuery = { __typename?: 'Query', user: { __typename?: 'User', userId: string, emailAddress: string, listings: Array<{ __typename?: 'UserListing', title: string, listingId: string, location: string, urlKey: string, enquiries: Array<{ __typename?: 'UserListingEnquiry', userId: string, enquiryId: string, listingId: string, name: string, emailAddress: string, message: string, phoneCountryCode: string | null, phoneNumber: string | null, lastUpdated: string } | null> | null } | null> | null } | null };

export type GetFeaturedFranchisesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturedFranchisesQuery = { __typename?: 'Query', featuredFranchises: Array<{ __typename?: 'FeaturedFranchise', listingId: string, title: string, url: string, imageUrl: string, location: string, investment: string }> };

export type MarketplaceInsightsSignupMutationVariables = Exact<{
  input: MarketplaceInsightsSignupInput;
}>;


export type MarketplaceInsightsSignupMutation = { __typename?: 'Mutation', marketplaceInsightsSignup: any | null };

export type GetListingProductsForPackagesPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingProductsForPackagesPageQuery = { __typename?: 'Query', listingProducts: Array<{ __typename?: 'ListingProduct', description: string, cost: number, productToken: string, productCode: ListingProductCode, legacyProductCode: string }> };

export type GetCheckoutPaymentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutPaymentPageQuery = { __typename?: 'Query', user: { __typename?: 'User', userView: { __typename?: 'LegacyUserView', client: { __typename?: 'UserViewClient', id: string, listings: Array<{ __typename?: 'ClientListing', id: number, isPremium: boolean, legacyProductCode: string | null }> } | null } | null } | null, listingProducts: Array<{ __typename?: 'ListingProduct', description: string, cost: number, productToken: string, productCode: ListingProductCode, legacyProductCode: string }> };

export type GetListingProductsForPaymentPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListingProductsForPaymentPageQuery = { __typename?: 'Query', listingProducts: Array<{ __typename?: 'ListingProduct', description: string, cost: number, productToken: string, productCode: ListingProductCode, legacyProductCode: string }> };

export type PayPerEnquiryRegistrationMutationVariables = Exact<{ [key: string]: never; }>;


export type PayPerEnquiryRegistrationMutation = { __typename?: 'Mutation', payPerLeadRegistration: any | null };

export type PurchaseAndActivateMutationVariables = Exact<{
  input: PurchaseAndActivateInput;
}>;


export type PurchaseAndActivateMutation = { __typename?: 'Mutation', purchaseAndActivate: any | null };

export type PurchaseFreemiumMutationVariables = Exact<{ [key: string]: never; }>;


export type PurchaseFreemiumMutation = { __typename?: 'Mutation', purchaseFreemium: any | null };

export type GetCheckoutPaymentSuccessPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCheckoutPaymentSuccessPageQuery = { __typename?: 'Query', user: { __typename?: 'User', userView: { __typename?: 'LegacyUserView', client: { __typename?: 'UserViewClient', id: string } | null } | null } | null, listingProducts: Array<{ __typename?: 'ListingProduct', description: string, cost: number, productToken: string, productCode: ListingProductCode, legacyProductCode: string }> };

export type UpdatePreferencesIndustryMutationVariables = Exact<{
  input: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdatePreferencesIndustryMutation = { __typename?: 'Mutation', updateBuyerPreferencesIndustry: any | null };

export type DecodeSearchCriteriaQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type DecodeSearchCriteriaQuery = { __typename?: 'Query', serpDecodeSearchCriteria: { __typename?: 'SerpSearchCriteria', keywords: string | null, opportunityTypes: Array<SearchCriteriaOpportunityType> | null, investmentLevel: { __typename?: 'SerpSearchCriteriaInvestmentLevel', min: number | null, max: number | null } | null, industries: Array<{ __typename?: 'SerpSearchCriteriaIndustry', id: string, urlKey: string, title: string }> | null, districts: Array<{ __typename?: 'SerpSearchCriteriaDistrict', id: string, urlKey: string, displayTitle: string }> | null } | null };

export type DeleteSavedListingMutationVariables = Exact<{
  input: DeleteSavedListingInput;
}>;


export type DeleteSavedListingMutation = { __typename?: 'Mutation', deleteSavedListing: any | null };

export type DeleteSavedSearchMutationVariables = Exact<{
  input: DeleteSavedSearchInput;
}>;


export type DeleteSavedSearchMutation = { __typename?: 'Mutation', deleteSavedSearch: any | null };

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: any | null };

export type GetBuyerEmailAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBuyerEmailAddressQuery = { __typename?: 'Query', buyer: { __typename?: 'Buyer', emailAddress: string } | null };

export type GetFilteredDistrictsForProfileQueryVariables = Exact<{
  searchString: Scalars['String']['input'];
  hierarchies: InputMaybe<Array<InputMaybe<ListingDistrictHierarchy>> | InputMaybe<ListingDistrictHierarchy>>;
}>;


export type GetFilteredDistrictsForProfileQuery = { __typename?: 'Query', filteredListingDistrictsInHierarchies: { __typename?: 'ListingDistricts', districts: Array<{ __typename?: 'ListingDistrict', title: string, id: string } | null> | null } | null };

export type GetSavedListingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedListingsQuery = { __typename?: 'Query', savedListings: Array<{ __typename?: 'SavedListing', listingId: string, savedDate: string | null, createdDate: string, expiryDate: string, price: string, title: string, urlKey: string, imageUrl: string, opportunityType: string, location: string, businessName: string }> };

export type GetSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSavedSearchesQuery = { __typename?: 'Query', savedSearches: Array<{ __typename?: 'SavedSearch', id: string, savedDate: string, searchName: string, searchUrl: string }> };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'User', firstName: string, lastName: string, phoneCountryCode: string | null, phoneNumber: string | null, regionId: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: any | null };

export type UpdateUserMutationVariables = Exact<{
  input: UserUpdatedInput;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: any | null };

export type GetIndustryDisplayNameByIdsQueryVariables = Exact<{
  industryIds: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetIndustryDisplayNameByIdsQuery = { __typename?: 'Query', getIndustryDisplayNameByIds: string | null };

export type UpgradeContractRequestMutationVariables = Exact<{
  input: ContractUpgradeRequestInput;
}>;


export type UpgradeContractRequestMutation = { __typename?: 'Mutation', upgradeContractRequest: any | null };


export const GetUserEmailVerifiedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserEmailVerified"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"emailVerified"}}]}}]}}]} as unknown as DocumentNode<GetUserEmailVerifiedQuery, GetUserEmailVerifiedQueryVariables>;
export const SendEmailVerificationLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendEmailVerificationLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendEmailVerificationLink"}}]}}]} as unknown as DocumentNode<SendEmailVerificationLinkMutation, SendEmailVerificationLinkMutationVariables>;
export const GetDistrictsByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDistrictsByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"queryInput"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDistrictsByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"districtIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"queryInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayTitle"}}]}}]}}]}}]} as unknown as DocumentNode<GetDistrictsByIdsQuery, GetDistrictsByIdsQueryVariables>;
export const GetListingsTabDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingsTab"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"autoRenew"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"creditRemaining"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"isDeleted"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"contactCount"}},{"kind":"Field","name":{"kind":"Name","value":"enquiryCount"}},{"kind":"Field","name":{"kind":"Name","value":"listingCount"}},{"kind":"Field","name":{"kind":"Name","value":"searchCount"}},{"kind":"Field","name":{"kind":"Name","value":"isListingEmailBoosted"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"canBoost"}},{"kind":"Field","name":{"kind":"Name","value":"baseContract"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"clientId"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"legacyContractId"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"productTitle"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiredDate"}},{"kind":"Field","name":{"kind":"Name","value":"activeDate"}},{"kind":"Field","name":{"kind":"Name","value":"contractId"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"productToken"}}]}}]}}]} as unknown as DocumentNode<GetListingsTabQuery, GetListingsTabQueryVariables>;
export const GetPrivateSellerEnquiriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPrivateSellerEnquiries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"listingId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"listingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"enquiries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"enquiryId"}},{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastUpdated"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetPrivateSellerEnquiriesQuery, GetPrivateSellerEnquiriesQueryVariables>;
export const GetFeaturedFranchisesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFeaturedFranchises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredFranchises"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"investment"}}]}}]}}]} as unknown as DocumentNode<GetFeaturedFranchisesQuery, GetFeaturedFranchisesQueryVariables>;
export const MarketplaceInsightsSignupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarketplaceInsightsSignup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MarketplaceInsightsSignupInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"marketplaceInsightsSignup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<MarketplaceInsightsSignupMutation, MarketplaceInsightsSignupMutationVariables>;
export const GetListingProductsForPackagesPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingProductsForPackagesPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"productToken"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}}]}}]}}]} as unknown as DocumentNode<GetListingProductsForPackagesPageQuery, GetListingProductsForPackagesPageQueryVariables>;
export const GetCheckoutPaymentPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCheckoutPaymentPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"listings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isPremium"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"productToken"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}}]}}]}}]} as unknown as DocumentNode<GetCheckoutPaymentPageQuery, GetCheckoutPaymentPageQueryVariables>;
export const GetListingProductsForPaymentPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetListingProductsForPaymentPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"productToken"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}}]}}]}}]} as unknown as DocumentNode<GetListingProductsForPaymentPageQuery, GetListingProductsForPaymentPageQueryVariables>;
export const PayPerEnquiryRegistrationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PayPerEnquiryRegistration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payPerLeadRegistration"}}]}}]} as unknown as DocumentNode<PayPerEnquiryRegistrationMutation, PayPerEnquiryRegistrationMutationVariables>;
export const PurchaseAndActivateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurchaseAndActivate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PurchaseAndActivateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseAndActivate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<PurchaseAndActivateMutation, PurchaseAndActivateMutationVariables>;
export const PurchaseFreemiumDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PurchaseFreemium"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"purchaseFreemium"}}]}}]} as unknown as DocumentNode<PurchaseFreemiumMutation, PurchaseFreemiumMutationVariables>;
export const GetCheckoutPaymentSuccessPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCheckoutPaymentSuccessPage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userView"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"client"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"listingProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"cost"}},{"kind":"Field","name":{"kind":"Name","value":"productToken"}},{"kind":"Field","name":{"kind":"Name","value":"productCode"}},{"kind":"Field","name":{"kind":"Name","value":"legacyProductCode"}}]}}]}}]} as unknown as DocumentNode<GetCheckoutPaymentSuccessPageQuery, GetCheckoutPaymentSuccessPageQueryVariables>;
export const UpdatePreferencesIndustryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePreferencesIndustry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateBuyerPreferencesIndustry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdatePreferencesIndustryMutation, UpdatePreferencesIndustryMutationVariables>;
export const DecodeSearchCriteriaDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DecodeSearchCriteria"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"url"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"serpDecodeSearchCriteria"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"url"},"value":{"kind":"Variable","name":{"kind":"Name","value":"url"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"keywords"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityTypes"}},{"kind":"Field","name":{"kind":"Name","value":"investmentLevel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"min"}},{"kind":"Field","name":{"kind":"Name","value":"max"}}]}},{"kind":"Field","name":{"kind":"Name","value":"industries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"displayTitle"}}]}}]}}]}}]} as unknown as DocumentNode<DecodeSearchCriteriaQuery, DecodeSearchCriteriaQueryVariables>;
export const DeleteSavedListingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedListing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedListingInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedListing"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteSavedListingMutation, DeleteSavedListingMutationVariables>;
export const DeleteSavedSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSavedSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteSavedSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteSavedSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const GetBuyerEmailAddressDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetBuyerEmailAddress"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buyer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailAddress"}}]}}]}}]} as unknown as DocumentNode<GetBuyerEmailAddressQuery, GetBuyerEmailAddressQueryVariables>;
export const GetFilteredDistrictsForProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetFilteredDistrictsForProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hierarchies"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ListingDistrictHierarchy"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filteredListingDistrictsInHierarchies"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"searchString"},"value":{"kind":"Variable","name":{"kind":"Name","value":"searchString"}}},{"kind":"Argument","name":{"kind":"Name","value":"hierarchies"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hierarchies"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetFilteredDistrictsForProfileQuery, GetFilteredDistrictsForProfileQueryVariables>;
export const GetSavedListingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedListings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"listingId"}},{"kind":"Field","name":{"kind":"Name","value":"savedDate"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"expiryDate"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"urlKey"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"opportunityType"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"businessName"}}]}}]}}]} as unknown as DocumentNode<GetSavedListingsQuery, GetSavedListingsQueryVariables>;
export const GetSavedSearchesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSavedSearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"savedSearches"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"savedDate"}},{"kind":"Field","name":{"kind":"Name","value":"searchName"}},{"kind":"Field","name":{"kind":"Name","value":"searchUrl"}}]}}]}}]} as unknown as DocumentNode<GetSavedSearchesQuery, GetSavedSearchesQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"phoneCountryCode"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"regionId"}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const ResetPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdatedInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetIndustryDisplayNameByIdsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetIndustryDisplayNameByIds"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"industryIds"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getIndustryDisplayNameByIds"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"industryIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"industryIds"}}}]}]}}]} as unknown as DocumentNode<GetIndustryDisplayNameByIdsQuery, GetIndustryDisplayNameByIdsQueryVariables>;
export const UpgradeContractRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpgradeContractRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ContractUpgradeRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upgradeContractRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}]}]}}]} as unknown as DocumentNode<UpgradeContractRequestMutation, UpgradeContractRequestMutationVariables>;